function get() {
  return new Promise((resolve, reject) => {
    axios
      .get(`v1/jobs`)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((error) => {
        return reject(error);
      });
  });
}

function update(params) {
  return new Promise((resolve, reject) => {
    axios
      .post("v1/jobs/update", params, {
        "content-type": "multipart/form-data",
      })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((error) => {
        return reject(error);
      });
  });
}

function create(params) {
  return new Promise((resolve, reject) => {
    axios
      .post("v1/jobs", params, {
        "content-type": "multipart/form-data",
      })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((error) => {
        return reject(error);
      });
  });
}

function remove(id) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`v1/jobs/${id}`)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((error) => {
        return reject(error);
      });
  });
}

function getCandidateList(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`v1/jobs/candidates?job_id=${id}`)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((error) => {
        return reject(error);
      });
  });
}

function getFranchiseRequestsList() {
  return new Promise((resolve, reject) => {
    axios
      .get(`v1/franchise`)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((error) => {
        return reject(error);
      });
  });
}

function getContactUsRequestList(params = {}, filters = {}) {
  const { page = 0, itemsPerPage = 25 } = params
  const { user_id, ...restFilters } = filters

  return new Promise((resolve, reject) => {
    axios
      .get(`v1/contact_us`, {params: {page, itemsPerPage, user_id: user_id?.id || '', ...restFilters}})
      .then((response) => {
        return resolve(response.data);
      })
      .catch((error) => {
        return reject(error);
      });
  });
}

function sendContactListNotes(params = {}) {
  const { id = null, note = null, invoice_number = null, method_of_contact = null } = params
  return new Promise((resolve, reject) => {
    axios
        .post('v1/contact_us/add_note', { note, id, invoice_number, method_of_contact })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((error) => {
          return reject(error);
        });
  });
}

const Gallery = {
  get,
  update,
  create,
  remove,
  getCandidateList,
  getFranchiseRequestsList,
  getContactUsRequestList,
  sendContactListNotes
};

let axios = null;

export default ($axios) => {
  axios = $axios;
  return Gallery;
};
